(() => {
  const SELECTOR = '[data-collection-faq]';

  function initialise(root = document) {
    root.querySelectorAll(SELECTOR).forEach((section) => {
      if (section.dataset.faqInitialised === 'true') return;
      section.dataset.faqInitialised = 'true';

      const items = Array.from(section.querySelectorAll('details[data-faq-item]'));

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          items.forEach((otherItem) => {
            if (otherItem !== item) otherItem.open = false;
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
